import React, { ReactElement } from 'react';

import { getDisplayName } from '@cp-shared-19/frontend-ui';
import { Spinner } from '../spinner';

export type withLoadingHandlerProps = {
    isLoading: boolean;
    loadingPlaceholder?: ReactElement;
};

export const withLoadingHandler = <TProps extends Record<string, unknown>>(
    WrappedComponent: React.ComponentType<TProps>,
): React.FC<TProps & withLoadingHandlerProps> => {
    const Wrapper: React.FC<TProps & withLoadingHandlerProps> = ({
        isLoading,
        loadingPlaceholder,
        ...props
    }: withLoadingHandlerProps) =>
        isLoading ? loadingPlaceholder || <Spinner center={true} /> : <WrappedComponent {...(props as TProps)} />;

    Wrapper.displayName = `withLoadingHandler(${getDisplayName(WrappedComponent)})`;

    return Wrapper;
};
